const languages = [
    {
      code: 'tr',
      name: 'Turkish',
      country_code: 'tr',
    },
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
  ]

  export default languages
  